import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { NewCampaignEditContainer } from "@/components/features/marketing/campaign/edit/default/ui/new/container";

import { useGetCampaignCreateNewCampaignPageParams } from "./_hooks/use-get-campaign-edit-page-params";

export const MarketingCampaignCreateNewCampaignPage = () => {
	const { hotelID } = useGetCampaignCreateNewCampaignPageParams();

	return (
		<PageMeta title="新しいキャンペーンの作成" url={generatePath(PATHS.HOTEL.MARKETING.CAMPAIGN.NEW, { hotelID })}>
			<NewCampaignEditContainer hotelID={hotelID} />
		</PageMeta>
	);
};

MarketingCampaignCreateNewCampaignPage.displayName = "MarketingCampaignCreateNewCampaignPage";
